export const REFRESH_TOKEN_URL = {
  url: "/api/token/refresh_token/",
  isAuthorizationRequired: false,
};
export const LOGIN_URL = {
  url: "/api/login/",
  isAuthorizationRequired: false,
};
export const REGISTER_URL = {
  url: "/user/registration/",
  isAuthorizationRequired: false,
};
export const RESEND_VERIFICATION_CODE_URL = {
  url: "/user/send-verification-key/",
  isAuthorizationRequired: true,
};
export const VERIFY_ACCOUNT_URL = {
  url: "/user/verify-account/",
  isAuthorizationRequired: true,
};
export const FORGET_PASSWORD_URL = {
  url: "/user/reset-password-request/",
  isAuthorizationRequired: true,
};
export const RESET_PASSWORD_URL = {
  url: "/user/reset-password/",
  isAuthorizationRequired: true,
};

export const USER_DETAILS_URL = {
  url: "/user/details/",
  isAuthorizationRequired: true,
};

export const SHIPPER_PROFILE_URL = {
  url: "/shipper/profile/",
  isAuthorizationRequired: true,
};
export const CARRIER_PROFILE_URL = {
  url: "/carrier/profile/",
  isAuthorizationRequired: true,
};
export const USER_ORDER_N_EARNING_URL = (user_id) => {
  return {
    url: `/user/${user_id}/order-n-earning-stats/`,
    isAuthorizationRequired: true,
  };
};
export const GET_USER_PROFILE_VALUE_URL = (user_id) => {
  return {
    url: `/user/${user_id}/profile/`,
    isAuthorizationRequired: true,
  };
};

export const CARRIER_LIST_URL = (
  state = "",
  city = "",
  rating = "",
  load_type = "",
  name = "",
  pageNumber = 1
) => {
  return {
    url:
      "/carrier/?state=" +
      state +
      "&&city=" +
      city +
      "&&rating=" +
      rating +
      "&&load_type=" +
      load_type +
      "&&name=" +
      name +
      "&&page=" +
      pageNumber,
    isAuthorizationRequired: true,
  };
};

export const UPDATE_PROFILE_URL = {
  url: "/user/update_profile/",
  isAuthorizationRequired: true,
};
export const CHANGE_PASSWORD_URL = {
  url: "/user/change_password/",
  isAuthorizationRequired: true,
};
export const DELETE_ACCOUNT_URL = {
  url: "/user/delete-account/",
  isAuthorizationRequired: true,
};

export const COUNTRY_STATE_N_CITY_LIST_URL = {
  url: "/core/country-states-n-cities/",
  isAuthorizationRequired: false,
};

export const CHAT_MESSAGES_GET_URL = {
  url: "/chat/messages/",
  isAuthorizationRequired: true,
};
export const CHAT_ROOMS_GET_URL = {
  url: "/chat/rooms/",
  isAuthorizationRequired: true,
};
export const CHAT_ROOMS_SEARCH_URL = (searchParam) => {
  return {
    url: `/chat/rooms/search?q=${searchParam}`,
    isAuthorizationRequired: true,
  };
};
export const CHAT_ROOM_ATTACHMENTS_UPLOAD_URL = (room_channel_id) => {
  return {
    url: `/chat/upload-attachments/${room_channel_id}/`,
    isAuthorizationRequired: true,
  };
};
export const CHAT_ROOM_ATTACHMENTS_DELETE_URL = (room_channel_id) => {
  return {
    url: `/chat/remove-attachments/${room_channel_id}/`,
    isAuthorizationRequired: true,
  };
};
export const TRANSACTION_GET_URL = {
  url: "/payment/transaction-history/",
  isAuthorizationRequired: true,
};

export const NOTIFICATION_GET_URL = (pageNumber) => {
  return {
    url: "/notifications/?page=" + pageNumber,
    isAuthorizationRequired: true,
  };
};
export const MARK_NOTIFICATION_AS_READ_URL = {
  url: "/notifications/mark_all_as_read/",
  isAuthorizationRequired: true,
};
export const MARK_SINGLE_NOTIFICATION_AS_READ_URL = (notificationId) => {
  return {
    url: "/notifications/" + notificationId + "/mark_as_read/",
    isAuthorizationRequired: true,
  };
};
export const TOTAL_UNREAD_NOTIFICATION_NUMBER_URL = {
  url: "/notifications/total_unread_notification/",
  isAuthorizationRequired: true,
};
export const ROOM_MESSAGES_GET_URL = {
  url: "/chat/messages/",
  isAuthorizationRequired: true,
};
export const VIN_API_URL = "https://api.carmd.com/v3.0/decode";
export const APROXIMATE_LOAD_PRICE_URL = {
  url: "/loads/approximate-price/",
  isAuthorizationRequired: true,
};
export const CREATE_LOAD_URL = {
  url: "/loads/",
  isAuthorizationRequired: true,
};

export const GET_LOAD_LIST_URL = (
  state = "",
  city = "",
  rating = "",
  load_type = "",
  pageNumber = 1
) => {
  return {
    url:
      "/loads/?state=" +
      state +
      "&&city=" +
      city +
      "&&rating=" +
      rating +
      "&&load_type=" +
      load_type +
      "&&page=" +
      pageNumber,
    isAuthorizationRequired: true,
  };
};

export const SINGLE_LOAD_POST_GET_URL = (load_id) => {
  return {
    url: "/loads/" + load_id + "/",
    isAuthorizationRequired: true,
  };
};
export const SINGLE_LOAD_POST_UPDATE_URL = (load_id) => {
  return {
    url: "/loads/" + load_id + "/",
    isAuthorizationRequired: true,
  };
};
export const VALIDATE_LOADS_URL = {
  url: "/loads/validate-loads/",
  isAuthorizationRequired: true,
};

export const ORDERS_GET_URL = (orderStatus = "", pageNumber = "") => {
  return {
    url: "/orders/?status=" + orderStatus + "&&page=" + pageNumber,
    isAuthorizationRequired: true,
  };
};
export const SINGLE_ORDER_GET_URL = (order_id) => {
  return {
    url: "/orders/" + order_id + "/",
    isAuthorizationRequired: true,
  };
};
export const CHANGE_ORDER_STATUS = (order_id) => {
  return {
    url: "/orders/" + order_id + "/change_order_status/",
    isAuthorizationRequired: true,
  };
};

export const DISPUTES_GET_URL = (pageNumber = 1) => {
  return {
    url: "/disputes/?page=" + pageNumber,
    isAuthorizationRequired: true,
  };
};
export const DISPUTES_POST_URL = {
  url: "/disputes/",
  isAuthorizationRequired: true,
};
export const SINGLE_ORDER_DISPUTES_GET_URL = (order_id = "") => {
  return {
    url: `/orders/${order_id}/dispute-request/`,
    isAuthorizationRequired: true,
  };
};
export const WITHDRAW_ORDER_DISPUTES_POST_URL = (order_id = "") => {
  return {
    url: `/disputes/withdraw/${order_id}/`,
    isAuthorizationRequired: true,
  };
};
export const DISPUTES_OTHER_PARTY_RESPONSE_URL = (order_id = "") => {
  return {
    url: `/disputes/other-party-response/${order_id}/`,
    isAuthorizationRequired: true,
  };
};

export const OFFERS_GET_URL = (pageNumber = 1) => {
  return {
    url: "/loads/offers/?page=" + pageNumber,
    isAuthorizationRequired: true,
  };
};

export const LOAD_POST_OFFERS_GET_URL = (loadPostId) => {
  return {
    url: `/loads/${loadPostId}/offers/`,
    isAuthorizationRequired: true,
  };
};

export const GET_USER_REVIEWS_URL = (userId, pageNumber = 1) => {
  return {
    url: `/orders/review_n_rating/user/${userId}/?page=${pageNumber}`,
    isAuthorizationRequired: true,
  };
};
export const GET_ORDER_REVIEW_URL = (orderId) => {
  return {
    url: `/orders/${orderId}/review-n-rating/`,
    isAuthorizationRequired: true,
  };
};
export const POST_ORDER_REVIEW_URL = {
  url: "/orders/review_n_rating/",
  isAuthorizationRequired: true,
};

export const WITHDRAW_POST_URL = {
  url: "/withdraw/request/",
  isAuthorizationRequired: true,
};
export const WITHDRAW_GET_URL = {
  url: "/withdraw/request/",
  isAuthorizationRequired: true,
};
export const CANCEL_WITHDRAW_REQUEST_URL = (withdraw_id) => {
  return {
    url: `/withdraw/request/${withdraw_id}/cancel-withdraw-request/`,
    isAuthorizationRequired: true,
  };
};

export const LOADS_LIST_GET_URL = (pageNumber = 1) => {
  return {
    url: "/loads/shipper-loads/?page=" + pageNumber,
    isAuthorizationRequired: true,
  };
};
export const LOAD_POST_OFFER_SEND_URL = {
  url: "/loads/offers/",
  isAuthorizationRequired: true,
};
export const CARRIER_INDIVIDUAL_LOAD_POST_ACTIVITY_URL = (
  userId,
  loadPostId
) => {
  return {
    url: `/loads/${loadPostId}/carrier-individual-load-post-activity/${userId}/`,
    isAuthorizationRequired: true,
  };
};
export const LOAD_POST_OFFER_COUNTER_OFFER_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/make-counter-offer/`,
    isAuthorizationRequired: true,
  };
};
export const ACCEPT_COUNTER_OFFER_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/accept-counter-offer/`,
    isAuthorizationRequired: true,
  };
};
export const REJECT_COUNTER_OFFER_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/reject-counter-offer/`,
    isAuthorizationRequired: true,
  };
};
export const STOP_COUNTER_OFFER_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/stop-counter-offer/`,
    isAuthorizationRequired: true,
  };
};
export const LOAD_POST_WITHDRAW_URL = (loadPostId) => {
  return {
    url: `/loads/${loadPostId}/withdraw/`,
    isAuthorizationRequired: true,
  };
};
export const OFFER_WITHDRAW_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/withdraw/`,
    isAuthorizationRequired: true,
  };
};
export const OFFER_RE_ACTIVE_URL = (offerId) => {
  return {
    url: `/loads/offers/${offerId}/re-active-offer/`,
    isAuthorizationRequired: true,
  };
};
export const BANK_PAYMENT_POST_URL = {
  url: "/payment/bank/",
  isAuthorizationRequired: true,
};
export const PENDING_BANK_PAYMENT_REQUEST = {
  url: "/payment/bank/pending-payment-requests/",
  isAuthorizationRequired: true,
};
export const BALANCE_PAYMENT_URL = {
  url: "/payment/balance/",
  isAuthorizationRequired: true,
};
export const PAYPAL_PAYMENT_URL = {
  url: "/payment/paypal/",
  isAuthorizationRequired: true,
};
export const CARD_PAYMENT_URL = {
  url: "/payment/card/",
  isAuthorizationRequired: true,
};
export const PAYMENT_REQUEST_INFO_GET = (paymentRequestId) => {
  return {
    url: `/payment/payment-request-info/${paymentRequestId}/`,
    isAuthorizationRequired: true,
  };
};
export const PAYMENT_REQUEST_POST_URL = {
  url: `/payment/request/`,
  isAuthorizationRequired: true,
};
export const ADMIN_BANK_PAYMENT_INFO_GET = {
  url: "/payment/admin-bank-info/",
  isAuthorizationRequired: true,
};

export const CARRIER_ACTIVE_ORDER_LIST_URL = {
  url: "/carrier/active-orders-location/",
  isAuthorizationRequired: true,
};

export const FAVORITE_LIST_GET = {
  url: "/shipper/favorite-carriers/",
  isAuthorizationRequired: true,
};
export const REMOVE_FAVORITE_CARRIER_URL = (carrierId) => {
  return {
    url: `/shipper/remove-favorite-carrier/${carrierId}/`,
    isAuthorizationRequired: true,
  };
};
export const ADD_FAVORITE_CARRIER_URL = {
  url: `/shipper/add-favorite-carrier/`,
  isAuthorizationRequired: true,
};
export const CONTACT_US_URL = {
  url: `/core/contact-us/`,
  isAuthorizationRequired: false,
};
export const USER_BLOCK_URL = (userId) => {
  return {
    url: `/user/block/${userId}/`,
    isAuthorizationRequired: true,
  };
};
export const USER_UNBLOCK_URL = (userId) => {
  return {
    url: `/user/unblock/${userId}/`,
    isAuthorizationRequired: true,
  };
};
export const USER_BLOCK_LIST_URL = {
  url: "/user/blocked-list/",
  isAuthorizationRequired: true,
};
export const SAVE_BANK_CARD = {
  url: "/payment/save-card/",
  isAuthorizationRequired: true,
};
